import { AppState } from 'store/store';

export const searchSelector = (state: AppState) => state.search;
